import sendConventionApiRequest from "lib/send-convention-api-request"

export default async function postActiveAuthenticatedVisitors({
  // @ts-ignore PT - #180597146
  current,
  // @ts-ignore PT - #180597146
  convention_convention_id,
}) {
  await sendConventionApiRequest({
    current,
    method: "POST",
    url: `v1/convention_providers/${current.provider.id}/active_authenticated_visitors`,
    body: {
      data: {
        attributes: {
          convention_convention_id,
        },
      },
    },
  })
  return undefined
}
